/**
 * Rule 16 "System-disclosure text" (settled 2026-08-07, #89): pipeline
 * self-correction notes, semantic/inference-grouping caveats, and similar
 * meta commentary about how an answer was assembled render as ONE small,
 * muted paragraph placed directly under the content it qualifies — never an
 * ALL-CAPS titled subsection (that visual weight is reserved for clinical
 * content like Differential Diagnosis or Care Gaps), and never inside
 * Section 3 or the Clinical References sub-section. One shared treatment,
 * reused wherever this content type appears (self-correction, inferred
 * grouping, or similar), so callers never need to reinvent the styling.
 */
export function SystemDisclosure({ content }: { content: string }) {
  return (
    <p className="text-[12px] leading-relaxed text-muted-foreground/80">
      {content}
    </p>
  );
}
